<app-navbar />
<router-outlet />
<app-footer />
